<div class="center-content fade-in-animation">
  <div class="report-title">Métricas até o período: {{reports[0]?.date | date:'MM/yy' : 'UTC'}}</div>

  <div class="card">
    <div class="card-content" style="display: flex">
      <div class="card-info">
        <i class="fa fa-usd" aria-hidden="true"></i>
        <div class="card-title">
          Economia Potencial <info-tooltip [description]="'Descrição'"></info-tooltip>
        </div> {{(currentGroupData?.potentialEconomy | currency:'BRL':'symbol':'1.2-2') || '-'}}

        <div class="secondary-data">
          <div class="data-item">
            <span>Economia Lançada <info-tooltip [description]="'Descrição'"></info-tooltip></span>
            <b>{{(currentGroupData?.launchedEconomy | currency:'BRL':'symbol':'1.2-2') || '-'}}</b>
          </div>
        </div>
      </div>

      <div class="chart-container">
        <canvas id="economyChart" width="750" height="260"></canvas>
      </div>
    </div>
  </div>

  <div class="economy-cards">
    <div class="card">
      <div class="card-content">

        <div class="card-header">
          <h4 class="no-margin">Cupons</h4>
          <info-tooltip [description]="'Descrição'"></info-tooltip>
        </div>

        <div class="card-info">
          <div class="secondary-data">
            <div class="data-item">
              <span>Cupons Gerados</span>
              <b>{{(currentGroupData?.coupons | number: '1.0-3') || '-'}}</b>
            </div>
            <div class="data-item">
              <span>Economia Gerada</span>
              <b>{{(currentGroupData?.couponLaunchedEconomy | currency:'BRL':'symbol':'1.2-2') || '-'}}</b>
            </div>
          </div>
        </div>

        <ngx-datatable class="report-table" [headerHeight]="'auto'" [rowHeight]="28" [columnMode]="columnModes.flex"
          [rows]="rows" [columns]="columnsCoupons">
        </ngx-datatable>

      </div>
    </div>

    <div class="card">
      <div class="card-content">

        <div class="card-header">
          <h4 class="no-margin">Cinema</h4>
          <info-tooltip [description]="'Descrição'"></info-tooltip>
        </div>

        <div class="card-info">
          <div class="secondary-data">
            <div class="data-item">
              <span>Ingressos Vendidos</span>
              <b>{{(currentGroupData?.cinema_tickets | number: '1.0-3') || '-'}}</b>
            </div>
            <div class="data-item">
              <span>Economia Gerada</span>
              <b>{{(currentGroupData?.cinema_value | currency:'BRL':'symbol':'1.2-2') || '-'}}</b>
            </div>
          </div>
        </div>

        <ngx-datatable class="report-table" [headerHeight]="'auto'" [rowHeight]="28" [columnMode]="columnModes.flex"
          [rows]="rows" [columns]="columnsTickets">
        </ngx-datatable>

      </div>
    </div>
  </div>
</div>